import { useEffect, useState } from "react";
import PaginationComponent from "../Pagination/PaginationComponent";
import ProductCard from "./ProductCard";
import { ProductService } from "../../services/productService";
// import { toast } from "react-toastify";
import CommonUtil from "../../utils/CommonUtil";
import { Spin } from "antd";

const ProductGridList = ({
  showTotalRecord = true,
  hasPagination = true,
  filterOptions,
  label,
  order,
  className,
  gridClassName,
  maxRecordForMobile = 8,
  page = 1,
  search = "",
}) => {
  const [currentPage, setCurrentPage] = useState(page);
  const pageSize = 10;
  const [isLoading, setIsLoading] = useState(false);

  const [products, setProducts] = useState([]);
  const [totalRecord, setTotalRecord] = useState(0);
  // const [loading, setLoading] = useState(false);

  const fetchProducts = async () => {
    try {
      setIsLoading(true);
      const response = await ProductService.getListProducts({
        page: currentPage,
        pageSize: pageSize,
        search: search,
        label: label,
        ...filterOptions,
        order: order,
      });
      if (!response.Data) {
        // toast.error("Lỗi lấy danh sách sản phẩm!");
        return;
      }
      const { totalRecord, listData } = response.Data;
      setTotalRecord(totalRecord);
      setProducts(listData);
    } catch (error) {
      // toast.error("Lỗi lấy danh sách sản phẩm!");
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    fetchProducts();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currentPage, pageSize, order, search, label, filterOptions]);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [currentPage]);

  useEffect(() => {
    if (page !== currentPage) setCurrentPage(page);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page]);

  const handlePageChange = (page) => {
    setCurrentPage(page);
  };

  return (
    <Spin spinning={isLoading}>
      <div
        className={CommonUtil.groupClass("flex flex-col gap-4 my-2", className)}
      >
        {/* Total Products */}
        {showTotalRecord && totalRecord > 0 && (
          <span className="text-gray-700 text-left lg:order-first">
            Số lượng sản phẩm: <strong>{totalRecord}</strong>
          </span>
        )}
        {/* Product Grid */}
        {products.length > 0 ? (
          <div className={CommonUtil.groupClass("grid gap-4", gridClassName)}>
            {products.map((p, i) => (
              <div
                key={p._id || i}
                className={i >= maxRecordForMobile ? "hidden lg:block" : ""}
              >
                <ProductCard product={p} />
              </div>
            ))}
          </div>
        ) : (
          !isLoading && (
            <span className="flex text-gray-500 text-sm justify-center mt-8">
              Không có sản phẩm nào
            </span>
          )
        )}

        {/* Pagination */}
        {hasPagination && totalRecord !== 0 && (
          <div className="flex justify-center mt-4">
            <PaginationComponent
              currentPage={currentPage}
              pageSize={pageSize}
              total={totalRecord}
              onChange={handlePageChange}
            />
          </div>
        )}
      </div>
    </Spin>
  );
};

export default ProductGridList;
